// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J_DV","question":"styles_question__D47ze","description":"styles_description__1S7Zo"};